<form [formGroup]="reportTemplateForm" class="column">
	<mat-form-field appearance="fill">
		<mat-label>Report Templates</mat-label>		
		<mat-select formControlName="reportTemplateSelect"
		(openedChange)="!disabled && loadData($event)"
			id="reportTemplateSelect"
			  [required]="required"
			(selectionChange)="select($event.value)"
			[panelClass]="'panelCustomSelect'" #matSelect>			
			<div class="scrollable-panel-location" [hidden]="isLoading">
						<mat-option [value]="1">ssdp-mpo1</mat-option> <!--      -->
						<mat-option [value]="2">ssdp-mpo2</mat-option> <!--       -->
						<mat-option [value]="3">ssdp-mpo5-6</mat-option> <!--       -->
						<mat-option [value]="4">ssdp-mpo5.1-6.1</mat-option> <!--  -->
						<mat-option [value]="5">ssdp-mpo7</mat-option>
						<mat-option [value]="6" >ssdp-mpo8</mat-option>
						<mat-option [value]="7">ssdp-mpo9</mat-option>
						<mat-option [value]="8">ssdp-mpo9.1</mat-option>
						<mat-option [value]="9">ssdp-mpo10</mat-option>
						<mat-option [value]="10">ssdp-mpo10.1</mat-option>
						<mat-option [value]="11">ssdp-mpo10.2</mat-option>
						<mat-option [value]="12">ssdp-mpo11</mat-option>
						<mat-option [value]="13">ssdp-mpo11.1</mat-option>
						<mat-option [value]="14">ssdp-mpo13</mat-option>
						<mat-option [value]="15">ssdp-mpo13.1</mat-option>
						<mat-option [value]="16">ssdp-annualreport</mat-option>										
					</div>
		</mat-select>
	</mat-form-field>		
</form>